import {useProductDataStore} from '@/store/product-data'
import {useI18n} from 'vue-i18n'

interface BrandLogo {
  url: string
}

export interface Brand {
  id: number
  Brand: string
  BrandDescription: string
  important_message: number | null
  Code: string
  locale: string
  SmallLogo: BrandLogo | null
  BigLogo: BrandLogo | null
}

export function useBrand() {
  const {defaultLocale} = useI18n()

  function getBrandByCode(code: string, localeParam: string): Brand | undefined {
    const storebrands = useProductDataStore().brands
    let brand = storebrands?.find((b: Brand) => b.Code === code && b.locale === localeParam)
    if (brand === undefined) {
      brand = storebrands?.find((b: Brand) => b.Code === code && b.locale === defaultLocale)
    }
    return brand
  }

  function getBrandByName(brand: string, localeParam: string): Brand | undefined {
    const storebrands = useProductDataStore().brands
    let storedBrand = storebrands?.find((b: Brand) => b.Brand === brand && b.locale === localeParam)
    if (storedBrand === undefined) {
      storedBrand = storebrands?.find((b: Brand) => b.Brand === brand && b.locale === defaultLocale)
    }
    return storedBrand
  }

  return {
    getBrandByCode,
    getBrandByName
  }
}
